import {createContext} from "react";
import {StylesContextProps} from "~/context/StylesContext.props";

export const StylesContext = createContext<StylesContextProps>({styles: undefined});

export default StylesContext;
